module.exports = __webpack_public_path__ + "img/Cube.c82d571c.svg";